const locale = {
	name:'名前',
	email:'メール',
	project:'現場',
    actions:'オプション',
	create_member: 'ユーザーを追加',
	all_users: '全員',
	members:'ユーザー',
	filter:'絞り込み',
	filter_by:'絞り込み条件:',
	reset_filters:'絞り込みをリセット',
	member_type: '権限',
	position:'役職',
	group_type: '本支店・現場',
	project_branch: '支店',
	affiliation: '所属',
	account_status: 'アカウント',
	status:'ステータス',
	search_member: '検索ユーザー',
	members_title: 'ユーザータイトル',
	edit_details: '編集',
	change_password: 'パスワードを変更',
	activate_account: 'アカウントを有効化',
	deactivate_account: 'アカウント無効化',
	recover_account: ' アカウントを復帰',
	add_member: 'ユーザーを追加',
	companies: '企業',
	active:'有効',
	inactive:'無効',
	unverified: '未確認',
	deleted: '削除',
	export: 'ファイルに出力',
	cancel:'キャンセル',
	submit:'登録',
	delete: '削除',
	update:'更新',
	select_member_type:'権限',
	select_group_type:'本支店・現場',
	select_affiliation:'所属',
	select_user_position: '位置',
	select_project:'現場',
	enter_name:'名前',
	enter_email: 'メール',
	delete_account: 'アカウントを削除',
	activate: '有効化する',
	deactivate: '無効化する',
	recover: '復帰する',
	do_you_want_to_activate_this_account: 'このユーザーを有効化しますか？',
	do_you_want_to_deactivate_this_account: 'このユーザーを無効化しますか？',
	do_you_want_to_delete_this_account: 'このユーザーを削除しますか？',
	do_you_want_to_recover_this_account: 'このユーザーを復帰しますか？',
	no_matching_records_found:'テーブル内のデータがありません',
	new_password: '新しいパスワード',
	enter_new_password: '新しいパスワード',
	confirm_password: '再入力',
	update_password: 'パスワードの更新',
	enter_confirm_password: '同じパスワードを入力',
	this_email_already_exist:'このメールアドレスは既に存在します',
	resend_verify_email: 'メールを再送',
	local_name: '日本語',
	reset_project: 'リセットする',
	remove_from_project:'現場から削除する',
	please_select_project: '現場を選んでください',
	please_select_project_branch: '支店を選んでください',
	view_project:'現場を見る',
	updated_succesfully: '更新成功',
	do_you_want_to_remove_this_project: 'この現場を削除しますか？ :',
	map_member: 'ユーザー割り当て',
	search_project: '検索',
	do_you_want_to_remove_this_member:'このユーザーを削除しますか？ :',
	loading : '読み込み中...',
	created_succesfully: '作成完了',
	invalid_email: 'メールアドレスが無効',
	invalid_name: '名前が無効',
	project_code: '現場コード:',
};

export default locale;